import {get, post} from 'Utils/apiUtil';
import {callApi} from 'Utils/apiUtil';
import {
    getEoneStListUrl,
    getPlatfmcodeListUrl,
    getStInforUrl,
    saveB2bPlatformUrl,
    editB2bPlatformUrl,
    updateB2bPlatformUrl,
    getMobileB2bPlatformListUrl
} from 'Utils/urlUtil';

export const GET_EONE_ST_LIST = 'GET_EONE_ST_LIST';
export const GET_PLATFM_CODE_LIST = 'GET_PLATFM_CODE_LIST';
export const GET_ST_INFOR = 'GET_ST_INFOR';
export const SAVE_B2B_PLATFORM = 'SAVE_B2B_PLATFORM';
export const GET_B2B_PLATFORM_LIST = 'GET_B2B_PLATFORM_LIST';
export const B2B_SEARCH_FIELD = 'B2B_SEARCH_FIELD';
export const B2B_FORM_EDIT_DATA = 'B2B_FORM_EDIT_DATA';
export const B2B_FORM_UPDATE = 'B2B_FORM_UPDATE';

export const getB2bPlatformList = data => dispatch => dispatch(post(getMobileB2bPlatformListUrl, data))
    .then(res => {
        dispatch({ type: GET_B2B_PLATFORM_LIST, payload: res });
        return res;
    });

// Update B2B management Search Fields
export const updateB2bListSearchFields = params => ({ type: B2B_SEARCH_FIELD, payload: params });

export const saveB2bPlatform = data => dispatch => dispatch(post(saveB2bPlatformUrl, data))
    .then(res => {
        dispatch({ type: SAVE_B2B_PLATFORM, payload: res });
        return res;
});

// B2B configuration edit update
export const updateB2bPlatform = data => dispatch => dispatch(post(updateB2bPlatformUrl, data))
    .then(res => {
        dispatch({ type: B2B_FORM_UPDATE, payload: res });
        return res;
});

//B2B configuration edit data
export const editB2bPlatform = (id) => (dispatch) => {
    dispatch({type: B2B_FORM_EDIT_DATA, payload: {}});
    return dispatch(get(`${editB2bPlatformUrl}`, {id:id})).then((res) => {
        dispatch({type: B2B_FORM_EDIT_DATA, payload: res.data});
        return res;
    });
};

// Get e1 shipTo list.
export const getEoneStList = (shipToNum) => (dispatch) => {
    dispatch({type: GET_EONE_ST_LIST, payload: {}});
    return dispatch(get(getEoneStListUrl, { stNumber: shipToNum })).then((res) => {
        dispatch({type: GET_EONE_ST_LIST, payload: res.data});
        return res;
    });
};

// Get Platfmcode list.
export const getPlatfmcodeList = (params) => (dispatch) => {
    dispatch({type: GET_PLATFM_CODE_LIST, payload: {}});
    return dispatch(get(getPlatfmcodeListUrl, params)).then((res) => {
        dispatch({type: GET_PLATFM_CODE_LIST, payload: res.data});
        return res;
    });
};

// Get Platfmcode list.
export const getStInforList = (params) => (dispatch) => {
    dispatch({type: GET_ST_INFOR, payload: {}});
    return dispatch(get(getStInforUrl, params)).then((res) => {
        dispatch({type: GET_ST_INFOR, payload: res.data});
        return res;
    });
};